
import { Component, Vue, Watch } from 'vue-property-decorator';
import isImageSizeValid from '@/util/is-image-size-valid';
import SingleImageUpload from '@/component/single-image-upload.vue';
import MultipleImageUpload from '@/component/multiple-image-upload.vue';
import storage from 'baimahu/storage';
import { UPLOAD_DIR } from '@/constants';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  collocation: `${FCAPI}/boss/ruan/collocation`,
  category: `${FCAPI}/boss/ruan/category`,
  product: `${FCAPI}/boss/ruan/product`,
};
@Component({
  components: {
    SingleImageUpload,
    MultipleImageUpload,
  },
})
export default class RuanProductDetail extends Vue {
  is_loading = false;
  UPLOAD_DIR = UPLOAD_DIR;
  form_item_layout = {
    labelCol: { span: 2 },
    wrapperCol: { span: 22 },
  };
  form: any = {
    name: {},
    collocation: {},
    subcollocation: {
      data: undefined,
    },
    category: {
      data: '',
    },
    texture: '',
    size: '',
    price: {},
    is_online: false,
    list_image: {
      data: '',
    },
    detail_image: {
      data: [],
    },
  };
  collocation_list = [];
  subcollocation_list = [];
  collocation_list_obj: any = {};
  subcollocation_list_obj: any = {};
  category_list = [];
  category_list_obj: any = {};
  preview_image = '';
  preview_visible = false;
  send_data: any = {};

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  @Watch('form.list_image.data')
  onChangeListImg() {
    this.checkChange('list_image');
  }

  @Watch('form.detail_image.data')
  onChangeDetailImg() {
    this.checkChange('detail_image');
  }

  handlePreview(imageUrl: string) {
    this.preview_image = imageUrl;
    this.preview_visible = true;
  }

  handlePreviewCancel() {
    this.preview_visible = false;
  }

  beforeListImgUpload(file: any) {
    if (file.size / 1024 > 2048) {
      this.$message.error('图片过大，请上传 2M 以内图片');
      return false;
    }
    return isImageSizeValid(
      file,
      (width: number, height: number) => width === 750 && height === 750
    ).catch((data: any) => {
      const { width, height } = data;
      this.$message.error(
        `图片宽高限定 750*750px，当前上传图片宽高为 ${width}*${height}`
      );
      return Promise.reject(null);
    });
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      return error;
    } else if (field === 'collocation') {
      if (!this.form.collocation.data) {
        this.form.collocation.status = 'error';
        this.form.collocation.error = '请选择所属搭配';
        error = '1';
      } else {
        this.form.collocation.status = '';
        this.form.collocation.error = '';
      }
      return error;
    } else if (field === 'subcollocation') {
      if (!this.form.subcollocation.data) {
        this.form.subcollocation.status = 'error';
        this.form.subcollocation.error = '请选择所属子搭配';
        error = '1';
      } else {
        this.form.subcollocation.status = '';
        this.form.subcollocation.error = '';
      }
      return error;
    } else if (field === 'category') {
      if (!this.form.category.data) {
        this.form.category.status = 'error';
        this.form.category.error = '请选择所属品类';
        error = '1';
      } else {
        this.form.category.status = '';
        this.form.category.error = '';
      }
      return error;
    } else if (field === 'price') {
      if (!this.form.price.data) {
        this.form.price.status = 'error';
        this.form.price.error = '请输入价格';
        error = '1';
      } else {
        this.form.price.status = '';
        this.form.price.error = '';
      }
      return error;
    } else if (field === 'list_image') {
      if (!this.form.list_image.data) {
        this.form.list_image.status = 'error';
        this.form.list_image.error = '请上传列表图';
        error = '1';
      } else {
        this.form.list_image.status = '';
        this.form.list_image.error = '';
      }
      return error;
    } else if (field === 'detail_image') {
      if (this.form.detail_image.data.length <= 0) {
        this.form.detail_image.status = 'error';
        this.form.detail_image.error = '请上传详情图';
        error = '1';
      } else {
        this.form.detail_image.status = '';
        this.form.detail_image.error = '';
      }
      return error;
    }
    return error;
  }

  onSelectCollocation(value: any) {
    this.form.subcollocation.data = undefined;
    const subcollocation = this.collocation_list.filter((item: any) => {
      return item.id === value;
    });
    this.subcollocation_list = subcollocation[0]
      ? (subcollocation[0] as any).sub
      : [];
    this.subcollocation_list.forEach((item: any) => {
      this.subcollocation_list_obj[item.id] = item.name;
    });
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  sendData() {
    const form = this.form;
    const profile = storage.getItem('profile');
    const send_data: any = {
      name: form.name.data,
      collocation_id: form.collocation.data,
      collocation_name: this.collocation_list_obj[form.collocation.data],
      collocation_sub_id: form.subcollocation.data,
      collocation_sub_name: this.subcollocation_list_obj[
        form.subcollocation.data
      ],
      category_id: form.category.data,
      category_name: this.category_list_obj[form.category.data],
      texture: form.texture,
      size: form.size,
      price: form.price.data * 100,
      online_status: form.is_online ? 1 : 5,
      list_image_url: [form.list_image.data],
      detail_image_url: form.detail_image.data,
      account_id: profile.uid,
      account_name: profile.name,
    };
    if (!this.isNew) {
      send_data.id = this.id;
    }
    this.send_data = send_data;
  }

  submit() {
    if (!this.validator()) {
      return;
    }
    if (this.isNew) {
      this.add();
    } else {
      this.edit();
    }
  }

  async add() {
    this.sendData();
    const res = await this.$axios.post(API.product, this.send_data);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('新增成功');
    this.$router.push({
      path: '/ruan/product-list',
    });
  }

  async edit() {
    this.sendData();
    const res = await this.$axios.put(
      `${API.product}/${this.id}`,
      this.send_data
    );
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑成功');
    this.$router.push({
      path: '/ruan/product-list',
    });
  }

  async getCollocation() {
    const res = await this.$axios.get(API.collocation);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.collocation_list = data;
    this.collocation_list.forEach((item: any) => {
      this.collocation_list_obj[item.id] = item.name;
    });
  }

  async getCategory() {
    const res = await this.$axios.get(API.category);
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    this.category_list = data;
    this.category_list.forEach((item: any) => {
      this.category_list_obj[item.id] = item.name;
    });
  }

  async query() {
    const res = await this.$axios.get(
      `${API.product}/${this.id}?id=${this.id}`
    );
    if (res.data.status !== 200) {
      return;
    }
    const data = res.data.data || {};
    const form = this.form;
    form.name.data = data.name;
    form.collocation.data = data.collocation_id;
    this.onSelectCollocation(form.collocation.data);
    form.subcollocation.data = data.collocation_sub_id;
    this.send_data.collocation_name = this.collocation_list_obj[
      form.collocation.data
    ];
    this.send_data.collocation_sub_name = this.subcollocation_list_obj[
      form.subcollocation.data
    ];
    form.category.data = data.category_id;
    form.texture = data.texture;
    form.size = data.size;
    form.is_online = data.online_status === 1;
    form.price.data = data.price / 100;
    form.list_image.data = data.list_image_url[0];
    form.detail_image.data = data.detail_image_url;
  }

  async created() {
    await this.getCollocation();
    await this.getCategory();
    if (!this.isNew) {
      await this.query();
    }
  }
}
